import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { SuccessBadge } from '@hz-design-system/web-ui';

import Classes from './DiscountedBundlePriceBlock.module.scss';

type DiscountedBundlePriceBlockProps = {
  originalPrice: string;
  effectivePrice: string;
  discountPercentage: number;
};

const DiscountedBundlePriceBlock = ({
  originalPrice,
  effectivePrice,
  discountPercentage,
}: DiscountedBundlePriceBlockProps) => {
  const i18n = useI18nContext();
  return (
    <div className={Classes.root}>
      <div className={Classes.wrapDescription}>
        <SuccessBadge>{i18n.t('purchaseBundle.bundles.discountDescription', { discountPercentage })}</SuccessBadge>
      </div>
      <div className={Classes.wrapPrices}>
        <span className={Classes.originalPrice}>{originalPrice}</span>
        <span className={Classes.effectivePrice}>{effectivePrice}</span>
        <span className={Classes.priceFrequency}>{i18n.t('purchaseBundle.bundles.priceFrequencyWithDiscount')}</span>
      </div>
    </div>
  );
};

export default DiscountedBundlePriceBlock;
